import { configs } from './configs';
import type { ClientConfig } from './types';

const hostname = (host: string): string => host.split(':')[0] ?? host;

/** Exact host:port match first, then hostname only. Undefined = Alison. */
export function getConfig(host: string | undefined | null): ClientConfig | undefined {
  if (!host) return undefined;
  return (
    configs.find((c) => c.hosts.includes(host)) ??
    configs.find((c) => c.hosts.some((h) => hostname(h) === hostname(host)))
  );
}

/** https:// origin for every tenant host; localhost hosts get http://. For CORS + Better Auth. */
export function tenantOrigins(): string[] {
  return configs.flatMap((c) =>
    c.hosts.map((h) => `${h.startsWith('localhost') ? 'http' : 'https'}://${h}`),
  );
}
